export const sales = {
  quote: "Quote",
  quotesDescription: "Quotes become sales orders on acceptance.",
  inquiries: "Inquiries",
  salesOrders: "Sales orders",
  newQuote: "New quote",
  quotes: "Quotes",
  backToQuotes: "Back to quotes",
  notFound: "Quote not found.",
  declinedToast: "Quote declined",
  quoteTitle: "Quote {number}",
  revisionNo: "revision {no}",
  sentToast: "Quote sent",
  send: "Send",
  reviseToast: "New revision started",
  revise: "Revise",
  acceptToast: "Accepted — order created",
  accept: "Accept",
  decline: "Decline",
  declineTitle: "Decline this quote?",
  declineConfirm: "Decline quote",
  reasonOptional: "Reason (optional)",
  validUntil: "Valid until {date}",
  leadTime: "{days} days lead time",
  rfqsTitle: "Inquiries (RFQs)",
  rfqsDescription: "Customer requests waiting for a quote.",
  recordInquiry: "Record inquiry",
  recordInquiryTitle: "Record an inquiry",
  inquiry: "Inquiry",
  source: "Source",
  received: "Received",
  rfqs: "RFQs",
  saveInquiry: "Save inquiry",
  whatNeeded: "What do they need?",
  inquiryRecorded: "Inquiry recorded",
  convertHint:
    "Create a quote from the Quotes & orders page to turn this inquiry into a commercial offer.",
  salesOrdersDescription: "Confirmed work from accepted quotes.",
  order: "Order",
  ordered: "Ordered",
  lines: "Lines",
  emptyTitle: "No orders yet",
  emptyDescription: "Accept a quote to create a sales order.",
  createJobs: "Create jobs",
  createJobsFrom: "Create jobs from {order}?",
  createJobsDescription:
    "Each order line becomes a production job. Operations and materials seed from the quoted product.",
  targetDate: "Target date",
  jobsCreated: "Jobs created",
  jobsCreatedDesc: "{count} job(s) from {order}.",
  startQuote: "Start a quote",
  createQuote: "Create quote",
  fromInquiry: "From inquiry (optional)",
  linesHint: "Lines, prices, and estimates are added on the quote itself.",
  createdToast: "Quote created",
  quoteLines: "Quote lines",
  addLine: "Add line",
  noLines: "No lines yet. Add a line to build the quote.",
  product: "Product",
  estCost: "est. cost",
  lineType: "Line type",
  customLine: "Custom line",
  fromProduct: "From product",
  selectProduct: "Select a product…",
  adding: "Adding…",
  saveLine: "Save line",
  lineAdded: "Line added",
  lineUpdated: "Line updated",
  lineRemoved: "Line removed",
};
